import {
  DEMO_BOT_GAME_ACTIONS_SPEED_MAX_DELIMITER,
  HOT_SEAT_BOT_GAME_SPEED_DEFAULT,
  HOT_SEAT_BOT_GAME_SPEED_LOCAL_STORAGE_KEY,
} from './botConfig';

// Восстановление множителя скорости хода ботов локальной игры из localStorage:
// только целые значения, прижатые к 1..DEMO_BOT_GAME_ACTIONS_SPEED_MAX_DELIMITER;
// все прочее (мусор, недоступный localStorage, отсутствие записи) — скорость
// по умолчанию HOT_SEAT_BOT_GAME_SPEED_DEFAULT. Общая для HotSeatPlayersInitPage
// (слайдер) и GameContent (чтение один раз при старте игры).
export const readHotSeatBotSpeed = () => {
  try {
    const stored = localStorage.getItem(HOT_SEAT_BOT_GAME_SPEED_LOCAL_STORAGE_KEY);
    if (stored === null) return HOT_SEAT_BOT_GAME_SPEED_DEFAULT;
    const parsed = Number(stored);
    if (!Number.isInteger(parsed)) return HOT_SEAT_BOT_GAME_SPEED_DEFAULT;
    return Math.min(DEMO_BOT_GAME_ACTIONS_SPEED_MAX_DELIMITER, Math.max(1, parsed));
  } catch {
    return HOT_SEAT_BOT_GAME_SPEED_DEFAULT;
  }
};
